import fetch from "./fetch";
/**
 * 模版类型相关接口
 */
const meeting = {
  // 模版列表
  templatesRequst(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/page",
      method: "GET",
      params: data,
    });
  },
  // 新增模版
  saveTemplatesRequst(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/save",
      method: "POST",
      data,
    });
  },
  // 模版状态校验
  checkStatusTemplatesRequst(data) {
    return fetch({
      hideError: true,
      isLoading: true,
      url: "/questionnaireType/checkStatus",
      method: "GET",
      params: data,
    });
  },
  // 修改题型
  questionnaireUpdateRequst(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/update",
      method: "POST",
      data,
    });
  },
  // 删除题型(删除模版)
  questionnaireDeleteRequst(data) {
    return fetch({
      isLoading: true,
      url: "/questionnaireType/delete",
      method: "POST",
      data,
    });
  },
  // 获取图片地址
  getUrlRequst(id) {
    return fetch({
      url: "/file-data/getUrl",
      method: "GET",
      params: { id: id },
    });
  },
};

export default meeting;
